import React from "react";
import { motion } from "framer-motion";
import { CalendarDays, Clock3, Layers, RefreshCw } from "lucide-react";
import { formatDateIT, CATEGORIES } from "../lib/categories";

const Stat = ({ icon: Icon, label, value, sub, accent, delay, testid }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.5, delay }}
    data-testid={testid}
    className="bg-white p-6 rounded-3xl border border-gray-100 shadow-[0_2px_10px_rgba(0,0,0,0.02)] flex flex-col items-start transition-all hover:shadow-[0_12px_30px_rgba(0,0,0,0.07)] hover:-translate-y-1"
  >
    <span
      className="flex items-center justify-center w-11 h-11 rounded-2xl mb-4"
      style={{ background: `${accent}14`, color: accent }}
    >
      <Icon size={20} />
    </span>
    <span className="text-2xl sm:text-3xl font-display font-700 text-[#111827] tracking-tight leading-tight">
      {value}
    </span>
    <span className="text-sm text-gray-500 mt-1">{label}</span>
    {sub && <span className="text-xs text-gray-400 mt-0.5">{sub}</span>}
  </motion.div>
);

export const Dashboard = ({ stats }) => {
  if (!stats) return null;
  const next = stats.next_course;
  const nextLabel = next ? next.name : "—";
  const nextSub = next ? formatDateIT(next.date) : "";

  return (
    <div
      id="dashboard"
      data-testid="dashboard-stats"
      className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6"
    >
      <Stat
        testid="stat-total"
        icon={CalendarDays}
        value={stats.total_courses}
        label="Corsi disponibili"
        accent="#EA6A0A"
        delay={0}
      />
      <Stat
        testid="stat-next"
        icon={Clock3}
        value={nextSub || "—"}
        label="Prossimo corso"
        sub={nextLabel}
        accent="#2FA84F"
        delay={0.08}
      />
      <Stat
        testid="stat-categories"
        icon={Layers}
        value={stats.categories_count}
        label="Categorie"
        accent="#F97316"
        delay={0.16}
      />
      <Stat
        testid="stat-updated"
        icon={RefreshCw}
        value={formatDateIT(stats.last_updated)}
        label="Ultimo aggiornamento"
        sub={stats.session}
        accent="#8B5CF6"
        delay={0.24}
      />
    </div>
  );
};
